<template>
  <div class="inscription-bookings">
    <b-container>
      <h1>Inscription Bookings</h1>
      <b-row>
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input
                type="text"
                id="filterCriteria"
                v-model="filterCriteria"
                class="form-control"
                placeholder="Type to search"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"
                  ><b-icon icon="x-circle" variant="white"></b-icon
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="between">
        <b-col cols="3">
          <b-pagination
            v-model="currentPage"
            :page="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-button variant="primary" @click="addItem()"
        >Add</b-button
      >

      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        bordered
        :fields="item_fields"
        :filter="filterCriteria"
        :filter-included-fields="filterOn"
        :items="displayed_items"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >

      <template #cell(invoice_number)="row">
        <div
          class="table-button"
          @click="view_item(Object.assign({}, row.item))"
        >
          {{ row.item.invoice_number }}
        </div>
      </template>

      <template #cell(follower)="row">
        <div
          class="table-button"
          @click="follower_clicked(Object.assign({}, row.item))"
        >
          {{ row.item.follower }}
        </div>
      </template>

      <template #cell(container_no)="row">
        <div
          class="table-button"
          @click="container_no_clicked(Object.assign({}, row.item))"
        >
          {{ row.item.container_no }}
        </div>
      </template>

      <template #cell(booking_date)="row">
        <div
          class="table-button"
          @click="booking_date_clicked(Object.assign({}, row.item))"
        >
          {{ formatDate(row.item.booking_date) }}
        </div>
      </template>

      <template #cell(complete_date)="row">
        <div
          class="table-button"
          @click="complete_date_clicked(Object.assign({}, row.item))"
        >
          {{ formatDate(row.item.complete_date) }}
        </div>
      </template>
      
      <template #cell(files)="row">
        <div
          class="table-button"
          @click="files_clicked(Object.assign({}, row.item))"
        >
          {{ row.item.files.length }}
        </div>
      </template>
      
      </b-table>

    </b-container>

    <!-- VIEW ITEM -->
    <b-modal id="modal-view-item" hide-footer title="Add Item">
      <b-form>
        <label for="invoice_number">Invoice No.:</label>
        <b-input
          type="text"
          id="invoice_number"
          v-model="selected_item.invoice_number"
          required
        ></b-input>

        <label for="follower">Who is following:</label>
        <b-form-select
          id="follower"
          v-model="selected_item.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <label for="booking_date">Booking Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="booking_date"
          v-model="selected_item.booking_date"
          class="form-control"
        ></b-form-datepicker>

        <div class="fileUploadPanel">
          <label class="block-item m-0" for="files">Files:</label>
          <div v-if="this.selected_item.files.length > 0" class="file-list mb-1">
            <div v-for="(file, index) in selected_item.files" :key="index">
              <b-row class="mt-1 ml-1" align-h="between">
                <div>
                  {{ file.fileName }}
                  <b-icon
                    class="mt-1 pointer"
                    icon="arrow-down"
                    scale="1"
                    variant="success"
                    @click="downloadFile(index)"
                  ></b-icon>
                </div>
                <b-icon
                  class="mt-1 mr-4 pointer"
                  icon="trash-fill"
                  scale="1"
                  variant="danger"
                  @click="deleteFile(index)"
                ></b-icon>
              </b-row>
              <hr class="m-0 p-0" />
            </div>
          </div>
          <b-form-file
              v-model="selectedFile"
              :state="Boolean(selectedFile)"
              placeholder="Choose files or drop those here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <div>
              <b-row
                class="mt-1 ml-1"
                v-for="(file, index) in selectedFiles"
                :key="index"
              >
                {{ file.name }}
                <b-icon
                  class="mt-1 ml-1 pointer"
                  icon="x-circle"
                  scale="1"
                  variant="danger"
                  @click="removeFile(index)"
                ></b-icon>
              </b-row>
            </div>
          <b-button v-if="!isUploading"
              :disabled="
                this.selectedFiles.length == 0 || this.isProcessing
                  ? true
                  : false
              "
              class="mt-1"
              block
              variant="primary"
              @click="uploadFiles"
            >
              Upload</b-button
            >
          <b-button v-if="isUploading"
              :disabled="true"
              class="mt-1"
              block
              variant="primary"
            >
            <b-spinner small type="grow"></b-spinner>
              Uploading...</b-button
            >
        </div>

        <label class="block-item" for="description">Description:</label>
        <b-textarea
          type="text"
          id="description"
          v-model="selected_item.description"
        ></b-textarea>

        <div class="modal-footer">
          <b-button v-if="this.user.role == 'admin'" variant="danger" @click="delete_item(selected_item.id)"
            >Delete</b-button
          >
          <b-button @click="hideModal('modal-view-item')"> Return </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_item"
          >
            <span v-if="!isUpdating" :disabled="isUploading">Update</span>
            <span v-if="isUpdating" >
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- ADD ITEM -->
    <b-modal id="modal-add-item" hide-footer title="Add Item">
      <b-form @submit.prevent="add_report">
        <label for="invoice_number">Invoice No.:</label>
        <b-input
          type="text"
          id="invoice_number"
          v-model="new_item.invoice_number"
          required
        ></b-input>

        <label for="follower">Who is following:</label>
        <b-form-select
          id="follower"
          v-model="new_item.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <label for="booking_date">Booking Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="booking_date"
          v-model="new_item.booking_date"
          class="form-control"
        ></b-form-datepicker>

        <div class="fileUploadPanel">
          <label class="block-item m-0" for="files">Files:</label>
          <div v-if="this.selected_item.files.length > 0" class="file-list mb-1">
            <div v-for="(file, index) in selected_item.files" :key="index">
              <b-row class="mt-1 ml-1" align-h="between">
                <div>
                  {{ file.fileName }}
                  <b-icon
                    class="mt-1 pointer"
                    icon="arrow-down"
                    scale="1"
                    variant="success"
                    @click="downloadFile(index)"
                  ></b-icon>
                </div>
                <b-icon
                  class="mt-1 mr-4 pointer"
                  icon="trash-fill"
                  scale="1"
                  variant="danger"
                  @click="deleteFile(index)"
                ></b-icon>
              </b-row>
              <hr class="m-0 p-0" />
            </div>
          </div>
          <b-form-file
              v-model="selectedFile"
              :state="Boolean(selectedFile)"
              placeholder="Choose files or drop those here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <div>
              <b-row
                class="mt-1 ml-1"
                v-for="(file, index) in selectedFiles"
                :key="index"
              >
                {{ file.name }}
                <b-icon
                  class="mt-1 ml-1 pointer"
                  icon="x-circle"
                  scale="1"
                  variant="danger"
                  @click="removeFile(index)"
                ></b-icon>
              </b-row>
            </div>
          <b-button v-if="!isUploading"
              :disabled="
                this.selectedFiles.length == 0 || this.isProcessing
                  ? true
                  : false
              "
              class="mt-1"
              block
              variant="primary"
              @click="uploadFiles"
            >
              Upload</b-button
            >
          <b-button v-if="isUploading"
              :disabled="true"
              class="mt-1"
              block
              variant="primary"
            >
            <b-spinner small type="grow"></b-spinner>
              Uploading...</b-button
            >
        </div>

        <label class="block-item" for="description">Description:</label>
        <b-textarea
          type="text"
          id="description"
          v-model="new_item.description"
        ></b-textarea>

        <div class="modal-footer">
          <b-button v-if="this.user.role == 'admin'" variant="danger" @click="delete_item(viewed_item.id)"
            >Delete</b-button
          >
          <b-button @click="hideModal('modal-add-item')"> Return </b-button>
          <b-button
            :disabled="isUpdating"
            variant="primary"
            @click="addItemTask"
          >
            <span v-if="!isSubmitting" :disabled="isUploading">Create</span>
            <span v-if="isSubmitting" >
              <b-spinner small type="grow"></b-spinner>
              Creating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- EDIT COLUMNS -->
    <b-modal id="modal-edit-follower" hide-footer title="Sales">
      <b-form>
        <label for="follower">Who is following:</label>
        <b-form-select
          id="follower"
          v-model="selected_item.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-follower')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_item"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-container-no" hide-footer title="Container Number">
      <b-form>
        <label for="follower">Container Number:</label>
        <b-form-input
          id="container_no"
          v-model="selected_item.container_no"
          required
        ></b-form-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-container-no')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_item"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-booking-date" hide-footer title="Booking Date">
      <b-form>
        <label for="booking_date">Booking Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="booking_date"
          v-model="selected_item.booking_date"
          required
        ></b-form-datepicker>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-booking-date')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_item"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-complete-date" hide-footer title="Complete Date">
      <b-form>
        <label for="complete_date">Complete Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="complete_date"
          v-model="selected_item.complete_date"
          required
        ></b-form-datepicker>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-complete-date')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_item"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-files" hide-footer title="Files">
      <b-form>
        <div class="fileUploadPanel">
          <label class="block-item m-0" for="files">Files:</label>
          <div v-if="this.selected_item.files.length > 0" class="file-list mb-1">
            <div v-for="(file, index) in selected_item.files" :key="index">
              <b-row class="mt-1 ml-1" align-h="between">
                <div>
                  {{ file.fileName }}
                  <b-icon
                    class="mt-1 pointer"
                    icon="arrow-down"
                    scale="1"
                    variant="success"
                    @click="downloadFile(index)"
                  ></b-icon>
                </div>
                <b-icon
                  class="mt-1 mr-4 pointer"
                  icon="trash-fill"
                  scale="1"
                  variant="danger"
                  @click="deleteFile(index)"
                ></b-icon>
              </b-row>
              <hr class="m-0 p-0" />
            </div>
          </div>
          <b-form-file
              v-model="selectedFile"
              :state="Boolean(selectedFile)"
              placeholder="Choose files or drop those here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <div>
              <b-row
                class="mt-1 ml-1"
                v-for="(file, index) in selectedFiles"
                :key="index"
              >
                {{ file.name }}
                <b-icon
                  class="mt-1 ml-1 pointer"
                  icon="x-circle"
                  scale="1"
                  variant="danger"
                  @click="removeFile(index)"
                ></b-icon>
              </b-row>
            </div>
          <b-button v-if="!isUploading"
              :disabled="
                this.selectedFiles.length == 0 || this.isProcessing
                  ? true
                  : false
              "
              class="mt-1"
              block
              variant="primary"
              @click="uploadFiles"
            >
              Upload</b-button
            >
          <b-button v-if="isUploading"
              :disabled="true"
              class="mt-1"
              block
              variant="primary"
            >
            <b-spinner small type="grow"></b-spinner>
              Uploading...</b-button
            >
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="file-deletion-confirmation"
      hide-footer
      title="You are deleting a file"
    >
      <p>This file will be permanently deleted.</p>
      <div class="modal-footer">
        <b-button @click="hideModal('file-deletion-confirmation')">
          Cancel
        </b-button>
        <b-button variant="danger" @click="deleteFileTask"> Delete </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  data() {
    return {
      model: "",
      time_range: {
        start: "",
        end: "",
      },
      item_id: "",
      item_ref: null,
      uploadedFiles: [],
      uploadedFileNames: [],
      time_filtered_reports: [],
      sales: [],
      sales_names: [],
      cemeteries: [],
      cemeterys: [],
      perPage: 20,
      currentPage: 1,
      selectedFile: null,
      selectedFiles: [],
      filterCriteria: "",
      tableIsBusy: false,
      deleted_report_id: "",
      item_fields: [
        { key: "invoice_number", label: "Invoice #" },
        { key: "follower", label: "Sales" },
        { key: "container_no", label: "Container No."},
        { key: "booking_date", label: "Booking Date"},
        { key: "complete_date", label: "Complete Date"},
        { key: "files", label: "files"},
      ],
      displayed_items: [],
      items: [],
      new_item: {
        created_by: "",
        created_date: "",
        id: "",
        follower: this.user.name,
        invoice_number: "",
        booking_date: "",
        complete_date: "",
        description: "",
        files: [],
        edit_histories: [],
      },
      viewed_item: {
        created_by: "",
        created_date: "",
        id: "",
        follower: "",
        invoice_number: "",
        booking_date: "",
        complete_date: "",
        description: "",
        files: [],
        edit_histories: [],
      },
      selected_item: {
        created_by: "",
        created_date: "",
        id: "",
        follower: "",
        invoice_number: "",
        booking_date: "",
        complete_date: "",
        description: "",
        files: [],
        edit_histories: [],
      },
      status_names: ["success", "pending", "fail"],
      isSubmitting: false,
      isUpdating: false,
      isDeleting: false,
      isComplete: false,
      isUploading: false,
      isProcessing: false,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      isFilesPending: false,
      filterOn: [
        "invoice_number",
        "follower",
        "container_no",
        "booking_date",
        "complete_date",
      ],
    };
  },
  props: {
    user: Object,
  },
  computed: {
    rows: {
      get() {
        if (this.displayed_items.length == 0) {
          return 100;
        } else {
          return this.displayed_items.length;
        }
      },
      set(newRows) {
        return newRows;
      },
    },
  },
  watch: {
    selectedFile(newSelectedFile) {
      if (this.selectedFile != null) {
        this.selectedFiles.push(newSelectedFile);
      }
    },
  },
  created() {
    this.set_global_date();

    if (this.user.role == "sales") {
      firebase
        .firestore()
        .collection("inscription_bookings")
        .where("follower", "==", this.user.name)
        .orderBy("invoice_number", "asc")
        .onSnapshot((collection) => {
          this.items = [];
          this.items = collection.docs.map((doc) => doc.data());
          this.displayed_items = this.items;
        });
    } else {
      firebase
        .firestore()
        .collection("inscription_bookings")
        .orderBy("invoice_number", "asc")
        .onSnapshot((collection) => {
          this.items = [];
          this.items = collection.docs.map((doc) => doc.data());
          this.displayed_items = this.items;
        });
    }

    firebase
    .firestore()
    .collection("saless")
    .onSnapshot((collection) => {
      this.sales = [];
      this.sales_names = [];
      this.sales = collection.docs.map((doc) => doc.data());
      for (var i = 0; i < this.sales.length; i++) {
        this.sales_names.push(this.sales[i].name);
      }
    });
  },
  methods: {
    formatDate(dateString) {
      if (!dateString || dateString == "") return "";
      const ymd = dateString.split("-");
      const monthString = ymd[1].charAt(0) == "0" ? ymd[1].slice(1) : ymd[1];
      return ymd[2] + "-" + this.monthNames[parseInt(monthString) - 1];
    },
    myRowClickHandler(item) {
      this.viewed_report = item;
      this.showModal("modal-view-report");
      console.log(item);
    },
    follower_clicked(item) {
      this.selected_item = item;
      this.showModal("modal-edit-follower");
      this.modal_id = "modal-edit-follower";
    },
    container_no_clicked(item) {
      this.selected_item = item;
      this.showModal("modal-edit-container-no");
      this.modal_id = "modal-edit-container-no";
    },
    booking_date_clicked(item) {
      this.selected_item = item;
      this.showModal("modal-edit-booking-date");
      this.modal_id = "modal-edit-booking-date";
    },
    complete_date_clicked(item) {
      this.selected_item = item;
      this.showModal("modal-edit-complete-date");
      this.modal_id = "modal-edit-complete-date";
    },
    files_clicked(item) {
      this.selected_item = item;
      this.showModal("modal-edit-files");
      this.modal_id = "modal-edit-files";
    },
    view_item(item) {
      this.selected_item = item;
      this.showModal("modal-view-item");
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, "0");
      var mm = String(date_time.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + "-" + mm + "-" + dd;
      this.new_item.date = this.today;
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
      this.selectedFile = null;
    },
    addItem() {
      this.model = "create";
      this.item_ref = firebase.firestore().collection("inscription_bookings").doc();
      this.new_item.id = this.item_ref.id;
      this.selected_item = this.new_item;
      this.showModal('modal-add-item');
    },
    addItemTask() {
      this.isSubmitting = true;

      this.new_item.created_date = this.today;
      this.new_item.created_date_timestamp = new Date(this.today);
      this.new_item.year_month = this.new_item.created_date.substring(0, 7);
      this.new_item.day = parseInt(
        this.new_item.created_date.substring(8, 10)
      );
      this.new_item.created_by = this.user;
      this.new_item.created_by_name = this.user.name;
      this.new_item.edit_histories.push({
        created_by: this.new_item.created_by,
        created_date: this.new_item.created_date,
        id: this.new_item.id,
        follower: this.new_item.follower,
        invoice_number: this.new_item.invoice_number,
        booking_date: this.new_item.booking_date,
        complete_date: this.new_item.complete_date,
        description: this.new_item.description,
        edit_by: this.user.name,
        edit_on: this.today,
      });

      firebase
        .firestore()
        .collection("inscription_bookings")
        .doc(this.new_item.id)
        .set(this.new_item).then(() => {
        this.hideModal("modal-add-report");
        const recipient = this.sales[
          this.sales_names.indexOf(this.new_item.follower)
        ];

        var email = {
          // to: [recipient.email],
          to: ['rick@johnstonemart.com'],
          message: {
            subject:
              "An inscription booking report has been generated",
            text:
              "Hi " +
              recipient.name +
              ", \n" +
              "The details of the additional inscription report are as follows:\n" +
              "Created by: " +
              this.new_item.created_by_name +
              "\n" +
              "Invoice #: " +
              this.new_item.invoice_number +
              "\n",
          },
        };

        firebase
          .firestore()
          .collection("mail")
          .add(email);

        this.new_item = {
          created_by: "",
          created_date: "",
          id: "",
          follower: this.user.name,
          invoice_number: "",
          booking_date: "",
          complete_date: "",
          description: "",
          files: [],
          edit_histories: [],
        };

        this.isSubmitting = false;
        this.model = "";
        this.hideModal("modal-add-item");
      });
    },
    uploadFiles() {
      console.log(this.selectedFiles);
      console.log(this.selected_item.files);
      for (var i = 0; i < this.selectedFiles.length; i++) {
        for (var c = 0; c < this.selected_item.files.length; c++) {
          if (this.selectedFiles[i].name == this.selected_item.files[c].fileName) {
            console.log(this.selectedFiles[i].name + this.selected_item.files[c].fileName);
            alert("Do not upload duplicate file!");
            return;
          }
        }
      }
      console.log("uploading starts");
      this.selectedFile = null;
      this.progress = 0;
      this.isUploading = true;
      this.isProcessing = true;

      if (this.selectedFiles.length > 0) {
        var storageRef = firebase.storage().ref();

        for (
          var fileIndex = 0;
          fileIndex < this.selectedFiles.length;
          fileIndex++
        ) {
          var fileName = this.selectedFiles[fileIndex].name;
          this.uploadedFileNames.push(fileName);
        }

        const directoryPrefix = "inscription_bookings/" + this.selected_item.id + "/";

        for (
          var uploadedFilseIndex = 0;
          uploadedFilseIndex < this.selected_item.files.length;
          uploadedFilseIndex++
        ) {
          this.uploadedFiles.push(this.selected_item.files[uploadedFilseIndex]);
        }

        this.uploadFileTask(storageRef, directoryPrefix, 0);
      }
    },
    uploadFileTask(storageRef, directoryPrefix, uploadedFilesCount) {
      if (uploadedFilesCount == this.selectedFiles.length) {
        this.uploadedFiles.concat(this.selected_item.files);
        var itemRef = firebase
          .firestore()
          .collection("inscription_bookings")
          .doc(this.selected_item.id);
        //var activeEventsRef = null;

        // if (itme.status == "active") {
        //   activeEventsRef = firebase
        //     .firestore()
        //     .collection("activeEvents")
        //     .doc(this.selectedEvent.id);
        //   activeEventsRef.set(
        //     {
        //       files: this.uploadedFiles,
        //     },
        //     { merge: true }
        //   );
        // }

        itemRef.set(
          {
            files: this.uploadedFiles,
          },
          { merge: true }
        );
        
        this.selected_item.files = this.uploadedFiles;
        console.log(this.selected_item.files);
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.uploadedFileNames = [];
        this.isComplete = true;
        this.isProcessing = false;
        this.isUploading = false;
        this.isFilesPending = true;
        alert("Upload successfully.");
        if (this.model != 'create') this.edit_item();
        return;
      }

      const self = this;
      const uploadingFile = this.selectedFiles[uploadedFilesCount];
      const uploadingTask = storageRef
        .child(directoryPrefix + uploadingFile.name)
        .put(uploadingFile, uploadingFile.type);
      //uploadingTasks.push(uploadingTask);
      uploadingTask.then((data) => {
        data.ref.getDownloadURL().then((url) => {
          self.uploadedFiles.push({
            fileName: this.uploadedFileNames[uploadedFilesCount],
            fileURL: url,
          });
          ++uploadedFilesCount;
          self.uploadFileTask(
            storageRef,
            directoryPrefix,
            uploadedFilesCount,
            false
          );
        });
      });
    },
    edit_item() {
      this.isUpdating = true;
      var updated_item = Object.assign({}, this.selected_item);
      delete updated_item.edit_histories;
      this.selected_item.edit_histories.push(updated_item);
      firebase
        .firestore()
        .collection("inscription_bookings")
        .doc(updated_item.id)
        .set(updated_item, { merge: true })
        .then(() => {
          //this.hideModal(this.modal_id);
          alert("Modify successfully");
          this.isUpdating = false;
          this.isFilesPending = false;
        });
    },
    downloadFile(index) {
      window.open(this.selected_item.files[index].fileURL);
    },
    deleteFile(index) {
      this.deletedFileIndex = index;
      this.showModal("file-deletion-confirmation");
    },
    deleteFileTask() {
      const index = this.deletedFileIndex;
      var deletedFile = this.selected_item.files[index];
      this.selected_item.files.splice(index, 1);

      var database = firebase.firestore();
      var itemRef = database.collection("inscription_bookings").doc(this.selected_item.id);

      itemRef
        .set(
          {
            files: this.selected_item.files,
          },
          { merge: true }
        )
        .then(() => {
          if (deletedFile.fileURL) {
            var storageRef = firebase.storage().ref();
            var desertRef = storageRef.child(
              "inscription_bookings/" + this.selected_item.id + "/" + deletedFile.fileName
            );

            // Delete the file
            desertRef
              .delete()
              .then(function() {})
              .catch(function(error) {
                alert(error);
              });
          }

          this.hideModal("file-deletion-confirmation");
        })
        .catch((error) => {
          console.log("Error updating document: ", error);
          alert("Error updating document: ", error);
        });
    },
    cleanFilterInfo() {
      this.filterCriteria = "";
    },
  },
}
</script>

<style>
.inscription-bookings {
  margin: 0;
}

.block-item {
  display: block;
}

.table-button {
  min-width: 65px;
  min-height: 24px;
  font-size: 14px;
}

.table-button:hover {
  color: blue;
  background-color: Gainsboro;
  text-decoration: underline;
}
</style>